<template>
    <section class="bg-cover bg-center w-full bg-[#090b14]"
    :style="{
    backgroundImage: `url(${imagemFundo})`,
    backgroundColor: 'rgba(0, 0, 0, 0.4)', // cor preta com 50% de opacidade
    backgroundBlendMode: 'overlay' // isso faz a cor se misturar com a imagem
  }">
        <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
            <router-link :to="rotaSpan" v-if="mostrarSpan"
                class="inline-flex justify-between items-center py-1 px-1 pr-4 mb-7 text-sm text-gray-700 bg-gray-100 rounded-full dark:bg-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                role="alert">
                <span class="text-xs bg-primary-600 rounded-full text-white px-4 py-1.5 mr-3">{{ spanTipo }}</span> <span
                    class="text-sm font-medium">{{ textoSpan }}</span>
                <svg class="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"></path>
                </svg>
            </router-link>
            <h1 class="mb-4 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl ">
                {{ titulo }}</h1>
            <p class="mb-4 text-lg font-normal text-white lg:text-xl sm:px-16 xl:px-48 ">{{ descricao }}</p>

            <router-link :to="rotaBotao" v-if="mostrarBotao">
                <button type="button"
                    class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100  text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 shadow-lg shadow-blue-500/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 cursor-pointer">
                    {{ botao }}
                    <svg class="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd"></path>
                    </svg>
                </button>
            </router-link>



        </div>
    </section>

</template>

<script>

export default {
    name: 'HeroSection',
    props: {
        titulo : {
            type: String
        },
        descricao : {
            type: String
        },
        botao : {
            type: String
        },
        mostrarBotao : {
            type: Boolean
        },
        rotaBotao: {
            type: String
        },
        mostrarSpan : {
            type: Boolean
        },
        textoSpan : {
            type: String
        },
        rotaSpan : {
            type: String
        },
        spanTipo : {
            type: String
        },
        fundo: {
            type : String,
            default: 'imagem-hero-desktop.webp'
        }
    },
    data() {
        const imagem = require(`@/assets/images/${this.fundo}`);
        return {
            imagemFundo : imagem
        }
    }

}
</script>

<style></style>